// extracted by mini-css-extract-plugin
module.exports = {"ruleCell":"src-containers-RulesOld-List-RulesRenderer-RuleRowText-styles___ruleCell"};